import { Box } from '@mui/material'
import { useAuth } from 'components/AuthProvider'
import { dashboardPath, welcomePath } from 'components/Routes'
import fineGoldImage from 'images/Golden.png'
import investments_card from 'images/investments_card.png'
import { default as shadowImage } from 'images/shadow.png'
import slider_image_3 from 'images/slider_image_3.png'
import slider_image_4 from 'images/slider_image_4.png'
import { useNavigate } from 'react-router-dom'
import useStyles from './styles'

interface SliderProps {
  id: number
  heading?: string[]
  paragraph: string[]
  image: string
  shadow?: string
  video?: string
}

export const slider: SliderProps[] = [
  {
    id: 1,
    paragraph: [],
    image: investments_card
  },
  {
    id: 2,
    paragraph: [
      'Every KIWI now has access to real gold, at wholesale prices... without the middlemen'
    ],
    image: fineGoldImage,
    shadow: shadowImage
  },
  {
    id: 3,
    paragraph: [
      'WE’RE CHANGING THE FACE OF OWNERSHIP WITH REAL THINGS. JOIN THE REAL REVOLUTION'
    ],
    image: slider_image_3,
    shadow: shadowImage
  },
  {
    id: 4,
    paragraph: [
      'YOUR GOLD IS STORED IN NZ’s MOST SECURE VAULT & OUR INNOVATIVE TECH KEEPS YOUR DATA SAFE'
    ],
    image: slider_image_4
  }
]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function PreviousButton(props: any) {
  const { classes } = useStyles()
  return (
    <Box component='div' className={classes.previous} onClick={props.onClick} />
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function NextButton(props: any) {
  const { classes } = useStyles()
  const navigate = useNavigate()

  const { user } = useAuth()

  const handleClick = () => {
    const isVerified =
      user?.profile?.onboarded || user?.profile?.partialIdentityVerified
    if (props.onClick) {
      props.onClick()
    } else {
      navigate(isVerified ? dashboardPath() : welcomePath())
    }
  }
  return <Box component='div' className={classes.next} onClick={handleClick} />
}
